import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Home } from './pages/Home';
import { Portal } from './pages/Portal';
import { Admin } from './pages/Admin';
import { Login } from './pages/Login';
import { Release } from './pages/Release';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/portal/:slug" element={<Portal />} />
        <Route path="/release/:slug" element={<Release />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
    </BrowserRouter>
  );
}
